import React from "react";
import BaseElement from "components/FormElements/BaseElement";

export default function LowTextInput(props) {
    const defaultProps = {
        label: null,
        id: "text-input",
        name: "text-input",
        type: "text",
        autoComplete: "off",
        placeholder: "",
        value: "",
        isError: false,
        errorText: "",
        variant: false,
        forwardRef: null,
        onEnter: () => {},
    };
    const useProps = Object.assign(defaultProps, {}, props);

    const label = (
        <label
            htmlFor={useProps.id}
            className="block text-sm font-medium text-gray-700"
        >
            {useProps.label}
        </label>
    );

    const input = (
        <input
            type={useProps.type || "text"}
            name={useProps.name}
            ref={useProps.forwardRef || null}
            placeholder={useProps.placeholder || ""}
            onKeyDown={(e) => {
                e.key === "Enter" && useProps.onEnter(e.target.value);
            }}
            className=" border-gray-300 focus:border-green-500 focus:ring-green-500  block w-full rounded-md py-2 px-4 shadow-sm disabled:bg-white sm:text-sm"
        />
    );

    const helperText = useProps.helpertext ? (
        <p className="mt-1.5 text-xs text-gray-500">{useProps.helpertext}</p>
    ) : (
        ""
    );

    return (
        <BaseElement
            {...useProps}
            label={useProps.label ? label : null}
            input={input}
            helpertext={helperText}
            errortext={null}
        />
    );
}
